var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.0875 19.4683C0.483146 19.4683 -0.00689173 19.9573 -0.00689173 20.5604C-0.00689173 21.1645 0.483146 21.6535 1.0875 21.6535C1.69185 21.6535 2.18188 21.1645 2.18188 20.5604C2.18188 19.9573 1.69185 19.4683 1.0875 19.4683Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44736 6.51343C4.843 6.51343 4.35297 6.02438 4.35297 5.42125C4.35297 4.81723 4.843 4.32819 5.44736 4.32819C6.05171 4.32819 6.54174 4.81723 6.54174 5.42125C6.54174 6.02438 6.05171 6.51343 5.44736 6.51343ZM4.3574 0.00634766L0.0144043 9.73955H3.25503V11.9062H2.15887L2.16951 14.0755H3.25503V16.2413H6.51693L2.1633 26.0064H11.98L23.9456 0.00634766H4.3574Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b15b3bd64c4430fd132fa0dec619f318.svg";
export { ForwardRef as ReactComponent };